module.exports = __webpack_public_path__ + "img/card_2.d608c3d9.jpg";